import { render, staticRenderFns } from "./ProgrammaEdit.vue?vue&type=template&id=7a06b5ea&scoped=true&"
import script from "./ProgrammaEdit.vue?vue&type=script&lang=js&"
export * from "./ProgrammaEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammaEdit.vue?vue&type=style&index=0&id=7a06b5ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a06b5ea",
  null
  
)

export default component.exports